import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { visualizerActions, uiActions } from '../../store';
import styles from './Visualizer.module.css';
import compareStyles from '../Compare/Compare.module.css';
import loading from './assets/loading.png';
import undo from './assets/undo.svg';
import redo from './assets/redo.svg';
import zoomIn from './assets/zoomIn.svg';
import zoomOut from './assets/zoomOut.svg';
import pick from './assets/pick.svg';
import SurfacesMenuList from '../SurfacesMenuList/SurfacesMenuList.jsx';


export default function Visualizer({
    handleCompareToggle,
    applyCompareSide,
    handleCompareSideChange,
    containerRef,
    afterWrapperRef,
    sliderRef,
    setIsDragging
}) {
    const urlParams = useParams();
    const dispatch = useDispatch();
    const activeSurface = useSelector(state => state.visualizer.activeSurface);
    const activeProductMenuTab = useSelector(state => state.visualizer.activeProductMenuTab);
    const activeFlooringSubMenuTab = useSelector(state => state.visualizer.activeFlooringSubMenuTab);
    const appliedProducts = useSelector(state => state.visualizer.appliedProducts);
    const compareData = useSelector(state => state.visualizer.compareData);
    const vizLoading = useSelector(state => state.ui.vizLoading);
    const updateSelStrings = useSelector((state) => state.visualizer.updateSelStrings);
    const surfaces = useSelector(state => state.visualizer.surfaceList);
    let sel = useSelector(state => state.visualizer.selString);

    const lvtData = useSelector((state) => state.visualizer.productDataBySeries[8645]) || [];
    const carpetData = useSelector((state) => state.visualizer.productDataBySeries[8639]) || [];
    const resilientSheetData = useSelector((state) => state.visualizer.productDataBySeries[8644,8643]) || [];
    const wallColorData = useSelector((state) => state.visualizer.productDataBySeries[7973]) || [];

    useEffect(() => {
        const vizId = compareData.active ? 'chamVizSub' : 'chamViz';
        const saveData = document.getElementById('chamViz').getSaveData();
        const specifier = saveData.spec=='' ? urlParams.specifier : saveData.spec;

        document.getElementById('chamViz').addEventListener('ready', function (result) {
            dispatch(visualizerActions.setSpecifier(specifier));
            document.getElementById('chamViz').useMouseovers = false;
             if(urlParams.sel != -1){
                restoreSelectionsBasedOnSel();
             }
        });

        
        if(urlParams.sel != -1){
            document.getElementById('chamViz').load(urlParams.specifier, urlParams.selString);
            
        } else if(saveData.spec==''){
            document.getElementById('chamViz').load(specifier, "-1");
        }
           

    }, [urlParams.specifier, dispatch]);

    useEffect(() => {
        document.getElementById(compareData.side).addEventListener('surface_apply_done', function () {
            dispatch(uiActions.setVizLoading(false));
        });
    });


    useEffect(() => {
        if(!compareData.active && appliedProducts && Object.keys(appliedProducts).length != 0){
            dispatch(visualizerActions.snapshotAppliedProducts());
        }
          
    }, [appliedProducts]); 

    const restoreSelectionsBasedOnSel = () => {
       
        const productIds = urlParams.selString.match(/\d+/g).map(Number);
        let flooringProduct = false;
        let wallProduct = false;

        productIds.forEach(productId => {
            if(lvtData[productId] != undefined){
                flooringProduct = lvtData[productId];
            }else if(carpetData[productId] != undefined){
                flooringProduct = carpetData[productId];
            }else if(resilientSheetData[productId] != undefined){
                flooringProduct = resilientSheetData[productId];
            }else if(wallColorData[productId] != undefined){
                wallProduct = wallColorData[productId];
            }
        });

        if(flooringProduct){
            dispatch(visualizerActions.setAppliedProduct({
                location: 'chamViz',
                surface: 'Floor',
                data: {
                    colorway: flooringProduct,
                    selStrings: null,
                    size: null,
                    install: 5983716,
                },
            }));
        }

        if(wallProduct){
            dispatch(visualizerActions.setAppliedProduct({
                location: 'chamViz',
                surface: 'Walls',
                data: {
                    colorway: wallProduct,
                    selStrings: null,
                    size: null,
                    install: null,
                },
            }));
        }

    };

    const handleUndo = () => {
        dispatch(visualizerActions.goBackward());
    };

    const handleRedo = () => {
        dispatch(visualizerActions.goForward());
    };

    const handleZoom = () => {
        
        dispatch(uiActions.setZoomModalActive(true));

    };

    const handleImageEdit = () => {
        window.location.href = `/IM.aspx?specifier=${urlParams.specifier}`;
    };

    const swapChamVizProducts = () => {
        const subVizProducts = appliedProducts?.chamVizSub || {};
        dispatch(visualizerActions.setAppliedProduct({
            location: 'chamViz',
            swapData: subVizProducts
        }));
    };

    const ensureMainVizSurfaceSelected = () => {
       
        //for when compare is open and a user selects a surface on the cham-viz sub side then closes the compare
        //this ensures the active surface is always set back to a cham-viz surface 
        if(activeSurface.location=='chamVizSub'){
            dispatch(visualizerActions.setActiveSurface(surfaces[0]));
            dispatch(visualizerActions.setActiveProductMenuTab('flooring'));
            dispatch(visualizerActions.setCompareData({ key: 'side', value: 'chamViz' }));
        }
        

    
    };

    const handleRotate = () => {
        let activeSel = -1;
        if(activeSurface == null)
            return false

        
        document.getElementById('chamViz').applyByFilter("", "", function () {
            if (this.name == activeSurface.name)
                activeSel = this.sel;
        });

        console.log('activeSel',activeSel)

        if(activeSel == -1)
            return false

        

        dispatch(uiActions.setVizLoading(true));
        const rotationMap = {
            "{40}": "{90}",
            "{90}": "{135}",
            "{135}": "{40}",
            "254252": "254253",
            "254253": "254254",
            "254254": "254255",
            "254255": "254252",
        };

        for (let key of Object.keys(rotationMap)) {
            if (activeSel.includes(key)) {
                activeSel = activeSel.replace(key, rotationMap[key]);
                break; // stop after first match
            }
        }

        document.getElementById('chamViz').applyByFilter("", "", function () {
            if (this.name === activeSurface.name) 
                if (activeSurface?.name === this.name) {
                if(activeSel != this.sel){
                    console.log('new sel after rotating:',activeSel)
                    return activeSel;
                }else{
                    console.log('sel is the same...')
                }
            }
        });
    };

    console.log('activeProductMenuTab',activeProductMenuTab)

    return (
        <div className={`${styles.vizContainer} ${vizLoading ? styles.loading : ''} ${compareData.active ? compareStyles.compareActive : ''}`}>
            <div className={styles.loadingScreen}>Loading...</div>
            {!compareData.active && (
               <>
                <div className={styles.surfacesListContainer}>
                    <SurfacesMenuList
                        location={'chamViz'}
                    />
                 </div>
                <div className={styles.flexRow}>
                    <div className={styles.compare} onClick={handleCompareToggle}>compare</div>
                     {activeFlooringSubMenuTab != 'Resilient Sheet' && (
                        <div className={styles.rotate} onClick={handleRotate}>rotate</div>
                    )}
                    <div className={styles.zoomIn} onClick={handleZoom}><img src={zoomIn} alt="Zoom In" /></div>
                    <div className={styles.undo} onClick={handleUndo}><img src={undo} alt="undo" /></div>
                    <div className={styles.redo} onClick={handleRedo}><img src={redo} alt="redo" /></div>
                    
                    {urlParams.specifier.includes("USER") && <button className={styles.edit} onClick={handleImageEdit}>Edit Image</button>}
                </div>
               </>
            )}

            <div className={compareStyles.compareSideBtnContainer}>
                <div
                    className={compareStyles.leftContainer}
                    onClick={() => handleCompareSideChange('chamVizSub')}
                >
                    <SurfacesMenuList location="chamVizSub" />

                    <button
                        className={styles.pick}
                        type="button"
                        onClick={(e) => {
                        e.stopPropagation(); // prevent parent div click
                        applyCompareSide('chamVizSub');
                        swapChamVizProducts();
                        ensureMainVizSurfaceSelected();
                        dispatch(visualizerActions.clearAppliedProductsByLocation('chamVizSub'));
                        }}
                    >
                        <img src={pick} alt="use this configuration and close" />
                    </button>
                </div>

                <div
                    className={compareStyles.rightContainer}
                    onClick={() => handleCompareSideChange('chamViz')}
                    >
                    <SurfacesMenuList location="chamViz" />

                    <button
                        className={styles.pickRight}
                        type="button"
                        onClick={(e) => {
                        e.stopPropagation();           // <-- block parent onClick
                        applyCompareSide('chamViz');
                        ensureMainVizSurfaceSelected();
                        dispatch(visualizerActions.clearAppliedProductsByLocation('chamVizSub'));
                        }}
                    >
                        <img src={pick} alt="use this configuration and close" />
                    </button>
                </div>

            </div>

            <div className={compareStyles.compareContainer} ref={containerRef}>
                <div className={compareStyles.afterWrapper} ref={afterWrapperRef}>
                    <cham-viz id="chamVizSub" spec="" width="1024" active="1"></cham-viz>
                </div>
                <cham-viz id="chamViz" spec="" width="1024" active="1"></cham-viz>
                <div
                    ref={sliderRef}
                    className={compareStyles.compareSlider}
                >
                    <div
                        className={compareStyles.handle}
                        onMouseDown={() => setIsDragging(true)}
                    ></div>
                </div>
            </div>

                                     <div id="loadScreen" className={styles.loadScreen}>
                    <img src={loading} alt="loading logo" />
                </div>
        </div>
    );
}
